import { render, staticRenderFns } from "./learnSpan.vue?vue&type=template&id=747c4704&scoped=true&"
import script from "./learnSpan.vue?vue&type=script&lang=js&"
export * from "./learnSpan.vue?vue&type=script&lang=js&"
import style0 from "./learnSpan.vue?vue&type=style&index=0&id=747c4704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c4704",
  null
  
)

export default component.exports